/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { languageAdd } from '../fn/language/language-add';
import { LanguageAdd$Params } from '../fn/language/language-add';
import { languageDelete } from '../fn/language/language-delete';
import { LanguageDelete$Params } from '../fn/language/language-delete';
import { LanguageDto } from '../models/language-dto';
import { languageGet$Json } from '../fn/language/language-get-json';
import { LanguageGet$Json$Params } from '../fn/language/language-get-json';
import { languageGet$Plain } from '../fn/language/language-get-plain';
import { LanguageGet$Plain$Params } from '../fn/language/language-get-plain';
import { languageSet } from '../fn/language/language-set';
import { LanguageSet$Params } from '../fn/language/language-set';

@Injectable({ providedIn: 'root' })
export class LanguageService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `languageGet()` */
  static readonly LanguageGetPath = '/api/Language/{productId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `languageGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  languageGet$Plain$Response(params: LanguageGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LanguageDto>>> {
    return languageGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `languageGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  languageGet$Plain(params: LanguageGet$Plain$Params, context?: HttpContext): Observable<Array<LanguageDto>> {
    return this.languageGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LanguageDto>>): Array<LanguageDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `languageGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  languageGet$Json$Response(params: LanguageGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LanguageDto>>> {
    return languageGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `languageGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  languageGet$Json(params: LanguageGet$Json$Params, context?: HttpContext): Observable<Array<LanguageDto>> {
    return this.languageGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LanguageDto>>): Array<LanguageDto> => r.body)
    );
  }

  /** Path part for operation `languageAdd()` */
  static readonly LanguageAddPath = '/api/Language/{productId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `languageAdd()` instead.
   *
   * This method doesn't expect any request body.
   */
  languageAdd$Response(params: LanguageAdd$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return languageAdd(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `languageAdd$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  languageAdd(params: LanguageAdd$Params, context?: HttpContext): Observable<void> {
    return this.languageAdd$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `languageSet()` */
  static readonly LanguageSetPath = '/api/Language/{productId}/{index}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `languageSet()` instead.
   *
   * This method doesn't expect any request body.
   */
  languageSet$Response(params: LanguageSet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return languageSet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `languageSet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  languageSet(params: LanguageSet$Params, context?: HttpContext): Observable<void> {
    return this.languageSet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `languageDelete()` */
  static readonly LanguageDeletePath = '/api/Language/{productId}/{index}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `languageDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  languageDelete$Response(params: LanguageDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return languageDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `languageDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  languageDelete(params: LanguageDelete$Params, context?: HttpContext): Observable<void> {
    return this.languageDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
